import { render, staticRenderFns } from "./EmptyState.vue?vue&type=template&id=5eda67f3&scoped=true&"
var script = {}
import style0 from "./EmptyState.vue?vue&type=style&index=0&id=5eda67f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eda67f3",
  null
  
)

export default component.exports